// extracted by mini-css-extract-plugin
module.exports = {"agreement":"Agreement_agreement__rZviT","buttons-container":"Agreement_buttons-container__2PgM_","buttons-centered":"Agreement_buttons-centered__1-Qb_"};